/* BENYAR: USD remains the actual Shopify/checkout currency.
 * This script converts labelled storefront prices for browsing only.
 * Rates: Frankfurter blended central-bank feed, usually updated daily.
 * On failed rate lookup, USD is shown rather than an invented rate. */
(function () {
 'use strict';
 var config=window.BenyarFXConfig||{};
 var country=config.country||'US';
 var language=config.language||'en';
 var currency=country==='IL'?'ILS':country==='GB'?'GBP':'USD';
 var base=config.base||'USD';
 var needsRate=base==='USD'&&currency!=='USD';
 var cacheKey='bny-fx-display-rates-usd';
 var ttl=26*60*60*1000;
 var rate=null,rateDate='';
 var timer=0;
 function active(){return !!(needsRate&&Number.isFinite(rate)&&rate>0);}
 function formatCents(value){
   var cents=Number(value);
   if(!Number.isFinite(cents))return '';
   var cc=active()?currency:'USD';
   var amount=Math.round(cents*(active()?rate:1))/100;
   try {return new Intl.NumberFormat(cc==='ILS'?'he-IL':cc==='GBP'?'en-GB':'en-US',{
     style:'currency',currency:cc,minimumFractionDigits:2,maximumFractionDigits:2
   }).format(amount);}
   catch(e){return amount.toFixed(2)+' '+cc;}
 }
 window.BenyarFX={
   baseCurrency:base,country:country,currency:currency,
   formatCents:formatCents,active:active,
   rate:function(){return active()?rate:1;},
   date:function(){return rateDate;}
 };
 if(!needsRate)return;
 function showNotice(){
   var el=document.getElementById('bny-fx-disclosure');
   if(!el)return;
   el.hidden=!active();
   if(active()){
     el.textContent=language==='he'
       ?'מחירי התצוגה בשקלים מבוססים על שער חליפין יומי ('+rateDate+'). התשלום בקופה מתבצע בדולר (USD).'
       :'Displayed '+currency+' prices use a daily exchange rate ('+rateDate+'). Checkout is charged in USD.';
   }
 }
 function convert(){
   if(!active())return;
   document.querySelectorAll('[data-bny-fx-cents],[data-bny-fx-range]').forEach(function(el){
     var next='';
     if(el.hasAttribute('data-bny-fx-range')){
       next=formatCents(el.getAttribute('data-bny-fx-min'))+' – '+formatCents(el.getAttribute('data-bny-fx-max'));
     } else {
       if(!el.hasAttribute('data-bny-fx-cents'))return;
       var raw=el.getAttribute('data-bny-fx-cents');
       if(raw===null||raw.trim()==='')return;
       next=formatCents(raw);
     }
     if(next&&el.textContent!==next)el.textContent=next;
   });
   showNotice();
 }
 function queue(){if(timer)return;timer=requestAnimationFrame(function(){timer=0;convert();});}
 function broadcast(){
   queue();
   try{document.dispatchEvent(new CustomEvent('bny:fx-ready'));}catch(e){}
 }
 function cached(){
   try{
     var entry=JSON.parse(localStorage.getItem(cacheKey)||'null');
     if(entry&&Date.now()-entry.at<ttl&&entry.rates&&Number(entry.rates[currency])>0){
       rate=Number(entry.rates[currency]);rateDate=entry.date||'';
     }
   }catch(e){}
 }
 cached();
 function apply(json){
   if(!Array.isArray(json))return;
   var rates={},date='';
   json.forEach(function(item){
     if(item&&String(item.base).toUpperCase()==='USD'&&
       (item.quote==='ILS'||item.quote==='GBP')&&Number(item.rate)>0){
       rates[item.quote]=Number(item.rate);date=item.date||date;
     }
   });
   if(!rates.ILS||!rates.GBP)return;
   rate=rates[currency];rateDate=date;
   try{localStorage.setItem(cacheKey,JSON.stringify({at:Date.now(),rates:rates,date:date}));}catch(e){}
   broadcast();
 }
 function init(){
   if(active())broadcast();
   var watcher=new MutationObserver(function(mutations){
     if(mutations.some(function(m){return m.type==='childList'||
       (m.type==='attributes'&&m.attributeName&&m.attributeName.indexOf('data-bny-fx-')===0);})){
       queue();
     }
   });
   watcher.observe(document.body,{
     childList:true,subtree:true,attributes:true,
     attributeFilter:['data-bny-fx-cents','data-bny-fx-min','data-bny-fx-max','data-bny-fx-range']
   });
   var controller=typeof AbortController==='function'?new AbortController():null;
   var expiry=controller?setTimeout(function(){controller.abort();},8000):null;
   fetch('https://api.frankfurter.dev/v2/rates?base=USD&quotes=ILS,GBP',{
     mode:'cors',credentials:'omit',signal:controller?controller.signal:undefined
   }).then(function(res){if(!res.ok)throw Error('FX request failed');return res.json();})
     .then(apply).catch(function(){if(active())broadcast();})
     .finally(function(){if(expiry)clearTimeout(expiry);});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
 else init();
 document.addEventListener('shopify:section:load',queue);
})();